<div class="flex justify-content-center align-items-center h-full">
  <svg [attr.width]="width()" [attr.height]="height()" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.95999 0.834961V2.91829M8.95999 13.96V17.2933M3.75166 8.95996H0.834991M16.6683 8.95996H15.4183M14.3409 14.3409L13.7517 13.7516M14.5135 3.47312L13.335 4.65163M3.0613 14.8587L5.41832 12.5016M3.23389 3.30053L5.00166 5.06829" [attr.stroke]="stroke()" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</div>
